import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.sessionStorage
})

const curUrl = window.location.href;

const store = new Vuex.Store({
  state: {
    priority: 0,
    colors: {
        yellow: '#FDB913',
        green: '#7BC143',
        blue: '#4BB8EF',
        orange: '#E65722',
        purple: '#7C2B83'
    },
    category: '',
    drivers: [],
    posts: [],
    activeFilters: {},
    production: curUrl.indexOf('localhost') === -1 ? true : false, // production use ===, for local dev use !==
    eventLogged: {
        landing: false,
        drivers: false
    },
    emails: '',
    mobileWidth: 768,
    isMobile: window.innerWidth < 768 ? true : false,
    isPortal: curUrl.indexOf('/portal') !== -1 ? true : false,
    isMobileDashboardOpen: false,
    activeDashboardKey: '',
    driverToReSwipe: 0
  },
  plugins: [vuexLocal.plugin],
  mutations: {
    changeCategory (state, payload) {
      state.category = payload;
    },
    getDrivers(state, payload) {
        state.drivers = payload;
    },
    updateDrivers(state, payload) {
        state.drivers = payload;
    },
    addDriver(state, payload) {
        state.selectedDrivers.push( payload );
    },
    removeDriver(state, payload) {
        state.selectedDrivers = state.selectedDrivers.filter(function(driver) {
            return driver.id !== payload.id
        });
    },
    updatePosts(state, payload) {
        state.posts = payload;
    },
    updateUser(state,payload) {

        for (let info in payload) {
            state[info] = info;
        }
    },
    addPriority(state, payload) {
        state.priority = state.priority + 1;
    },
    reducePriority(state, payload) {
        if ( state.priority > 0 ) {
            state.priority = state.priority - 1;
        }
    },
    updateActiveFilters(state, payload) {
        state.activeFilters = payload;
    },
    updateEventLogged(state, name) {
        state.eventLogged[name] = true;
    },
    updateEmailList(state, emails) {
        state.emails = emails;
    },
    updateIsMobile(state, value) {
        state.isMobile = value;
    },
    updateIsPortal(state, value) {
        state.isPortal = value;
    },
    updateIsMobileDashboardOpen(state, value) {
        state.isMobileDashboardOpen = value;
    },
    updateMobileWidth(state, value) {
        state.mobileWidth = value;
    },
    updateActiveDashboardKey(state, value) {
        state.activeDashboardKey = value;
    },
    setReSwipeDriver(state, driverId) {
        state.driverToReSwipe = driverId;
    }
  },
  actions: {
    changeCategory (state, payload) {
      state.commit('changeCategory', payload);
    },
    getDrivers (state, payload) {
        state.commit('getDrivers', payload);
    },
    updateDrivers( state, payload ) {
        state.commit('updateDrivers', payload);
    },
    addDriver ( state, payload ) {
        state.commit('addDriver', payload);
    },
    removeDriver (state, payload ) {
        state.commit('removeDriver', payload);
    },
    updatePosts (state, payload ) {
        state.commit('updatePosts', payload);
    },
    updateUser ( state, payload ) {
        state.commit('updateUser', payload);
    },
    addPriority( state, payload ) {
        state.commit('addPriority', payload);
    },
    reducePriority( state, payload ) {
        state.commit('reducePriority', payload);
    },
  },
  getters: {
    category(state) {
      return state.category;
    },
    drivers(state) {
        return state.drivers;
    },
    user(state) {
        return state.user;
    },
    colors(state) {
        return state.colors;
    },
    priority(state) {
        return state.priority;
    },
    posts(state) {
        return state.posts;
    },
    activeFilters(state) {
        return state.activeFilters;
    },
    production(state) {
        return state.production;
    },
    eventLoggedLanding(state) {
        return state.eventLogged.landing;
    },
    eventLoggedDrivers(state) {
        return state.eventLogged.drivers;
    },
    emails(state) {
        return state.emails;
    },
    isMobile(state) {
        return state.isMobile;
    },
    mobileWidth(state) {
        return state.mobileWidth;
    },
    isPortal(state) {
        return state.isPortal;
    },
    isMobileDashboardOpen(state) {
        return state.isMobileDashboardOpen;
    },
    activeDashboardKey(state) {
        return state.activeDashboardKey;
    },
    driverToReSwipe(state) {
        return state.driverToReSwipe;
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./resources/assets/js/store.js